// extracted by mini-css-extract-plugin
module.exports = {"container":"ev-pre-footer_container__F2p4N","preFooterImage":"ev-pre-footer_preFooterImage__E2CYe"};